import {
  FullCustodian,
  fullCustodianOptions,
} from "@fartherfinance/frontend/api/Types";

export type FullCustodianInclAll = FullCustodian | "All";

export const fullCustodianOptionsInclAll = [...fullCustodianOptions, "All"];
